import styles from './index.less';
import goldUrl from '@/assets/user/gold.png';
import { AccountBookOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import { Arrow } from '@react-vant/icons';

const UserAccount = () => {
  const { totalAmount } = useModel('useAccount', (model) => ({
    totalAmount: model.totalAmount,
  }));

  const goToPayment = () => {
    history.push('/payment');
  };

  const goToPaymentRecord = () => {
    history.push('/accountInformation');
  };

  return (
    <div className={styles.container}>
      <div className={styles['user-info']}>
        <div className={styles['account-info']}>
          <img src={goldUrl} alt={'gold'} />
          <p>账户余额￥</p>
        </div>
        {/*<div className={styles.user}>*/}
        {/*  账户名称：{basicAccountInformation?.accountName}*/}
        {/*</div>*/}
        <div onClick={goToPaymentRecord} className={styles.record}>
          充值记录 <Arrow className={styles.icon} />
        </div>
      </div>

      <div className={styles.amount}>
        <div className={styles['account-amount']}>{totalAmount}</div>
        <div className={styles['account-action']}>
          <div onClick={goToPayment} className={styles.btn}>
            <AccountBookOutlined /> 去充值
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAccount;
